import { createFileRoute } from "@tanstack/react-router";

import CancellationPage from "@/admin/reports/cancellation/page";

export const Route = createFileRoute("/app/$storeId/reports/cancellation")({
    component: RouteComponent,
});

function RouteComponent() {
    return <CancellationPage />;
}
